import { morphism, createSchema } from 'morphism';

const productDetailSkuSchema = createSchema(
  {
    sku: 'sku',
    code: 'code',
    name: 'name',
    price: 'prices.final',
    priceBreakdown: 'prices.breakdown',
    regularPrice: 'prices.regular',
    merchantSkuId: 'sku',
    attrs: 'attrs',
    internalSkuCode: 'internalSkuCode',
    images: 'images',
    url: 'url',
    orderable: 'orderable',
    meta: 'meta'
  },
  { undefinedValues: { strip: true } }
);

const productDetailSchema = createSchema(
  {
    skus: source => morphism(productDetailSkuSchema, source.skus),
    attrList: 'attrList'
  },
  { undefinedValues: { strip: true } }
);

export const tagSchema = createSchema(
  {
    name: 'name',
    order: 'order'
  },
  { undefinedValues: { strip: true } }
);

const searchProductSchema = createSchema(
  {
    id: 'merchantProductId',
    merchantProductId: 'merchantProductId',
    brand: 'brand',
    desc: 'description',
    images: 'images',
    orderable: () => true,
    meta: 'meta',
    name: 'name',
    attrList: 'attrList',
    prices: 'prices.final',
    regularPrices: 'prices.regular',
    shortDesc: 'shortDescription',
    url: 'url',
    skus: source => morphism(productDetailSkuSchema, source.skus)
  },
  { undefinedValues: { strip: true } }
);

export default {
  searchProductSchema,
  searchProducts: createSchema(
    {
      docs: source => morphism(searchProductSchema, source.docs),
      pagination: {
        limit: 'pagination.limit',
        page: 'pagination.page',
        nextPage: 'pagination.nextPage',
        hasNextPage: 'pagination.hasNextPage',
        total: 'pagination.totalDocs',
        nextCursor: 'pagination.nextCursor'
      }
    },
    { undefinedValues: { strip: true } }
  ),
  listTag: createSchema(
    {
      tags: 'data'
    },
    { undefinedValues: { strip: true } }
  ),
  productDetail: productDetailSchema
};
